import { useState } from 'react';
import { Plus } from 'lucide-react';

export default function Faq({ items, baseId = 'faq' }) {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid={`${baseId}-list`}>
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div className="acc-item" key={i}>
            <button
              type="button"
              className="acc-trigger"
              data-testid={`${baseId}-trigger-${i + 1}`}
              aria-expanded={isOpen}
              aria-controls={`${baseId}-panel-${i + 1}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
            >
              <span>{item.q}</span>
              <Plus size={18} className="acc-icon" />
            </button>
            <div
              id={`${baseId}-panel-${i + 1}`}
              className={'acc-panel' + (isOpen ? ' open' : '')}
              role="region"
            >
              <div>
                <p className="acc-content">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
